import { Images } from '@/assets/images';
import { DocTypeEnum, REGEX } from '@/constant';
import { cn, dayjs, diffDate, formatDate } from '@/utils';

import { isNotNilOrEmpty } from 'ramda-adjunct';
import * as Yup from 'yup';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	name: '',
	gender: '',
	birthDate: '',
	national: '',
	workPeriod: '',
	participationTime: '',
	participationMonth: '',
	workplace: '',
	city: '',
	position: '', // '시‧군',
	date: '',
	mayor: '',
	position1: '', // '시장‧군수',
	sealIdFilePath: '',
	district: '',
};
// PMF-03 (PM2_23)
type IValues = typeof initializeValue;

export const SEASONAL_WORKER_RE_ENTRY_RECOMMENDATION_CONFIRMATION_CONFIG: FormConfig<
	IValues,
	DocTypeEnum.PM2_23
> = {
	initializeValue,
	title: '계절근로자 재입국 추천 확인서',
	mapPropToValues({
		applicantData,
		franchiseData,
		detailData,
		unitData,
		applicantAssignmentListData,
	}) {
		const { adminInfo, unitInfo, applicantAssignment } = detailData || {};

		const address = franchiseData?.id
			? franchiseData?.address
			: applicantAssignment?.[0]?.address;
		const diffMonthWorkPeriod = diffDate(
			applicantAssignmentListData?.[applicantAssignmentListData?.length - 1]
				?.workEndDate,
			applicantAssignmentListData?.[applicantAssignmentListData?.length - 1]
				?.workStartDate,
			'month'
		);
		return {
			...initializeValue,
			name: applicantData?.fullName || '',
			national: applicantData?.nationalName || '',
			gender: isNotNilOrEmpty(applicantData?.genderName)
				? applicantData?.genderName === '남'
					? '남자'
					: '여자'
				: '',
			birthDate: applicantData?.birthDate || '',
			workplace:
				address && franchiseData?.employerName
					? `${address} / ${franchiseData?.employerName}`
					: address || franchiseData?.employerName || '',

			city: unitData?.name || unitInfo?.name || adminInfo?.unitName || '',
			mayor: unitData?.name || unitInfo?.name || adminInfo?.unitName || '',
			sealIdFilePath:
				unitData?.companySealFileId || adminInfo?.unitCompanySealFilePath || '',
			date: formatDate(dayjs()),
			workPeriod: applicantAssignmentListData?.[
				applicantAssignmentListData?.length - 1
			]?.workStartDate
				? `${formatDate(
						applicantAssignmentListData?.[
							applicantAssignmentListData?.length - 1
						]?.workStartDate
					)} ~ ${formatDate(
						applicantAssignmentListData?.[
							applicantAssignmentListData?.length - 1
						]?.workEndDate
					)}(${diffMonthWorkPeriod}개월)
				`
				: '',
			district: `${unitInfo?.cityProvince} ${unitInfo?.countyDistrict ? `(${unitInfo?.countyDistrict})` : ''}`,
		};
	},
	pages: [
		{
			background: {
				src: Images.formSeasonalWorkerReEntryRecommendationConfirmation,
				className: 'template',
				dataSource: Images.formSeasonalWorkerReEntryRecommendationConfirmation,
			},
			textAreas: [
				{
					name: 'name',
					maxHeight: 39,
					maxLength: 60,
					containerClassName: 'absolute top-[316px] left-[26.8%] w-[235px]',
					className: 'text-[16px] leading-none',
				},
				{
					name: 'gender',
					maxHeight: 39,
					maxLength: 10,
					containerClassName: 'absolute top-[316px] left-[69%] w-[137px]',
					className: 'text-[16px] leading-none text-center',
				},
				{
					name: 'national',
					maxHeight: 40,
					maxLength: 22,
					containerClassName: 'absolute top-[359px] left-[69%] w-[137px]',
					className: 'text-[16px] leading-none text-center',
				},
				{
					name: 'workPeriod',
					maxHeight: 60,
					maxLength: 34,
					containerClassName: 'absolute top-[403px] left-[26.8%] w-[235px]',
					className: 'text-[15px] text-center !h-[60px]',
				},
				{
					name: 'workplace',
					maxHeight: 54,
					maxLength: 100,
					containerClassName: 'absolute top-[466px] left-[26.8%] w-[473px]',
					className: 'text-[16px] leading-none text-center',
				},
				(values, index) => ({
					name: 'city',
					maxHeight: 22,
					maxLength: 8,
					containerClassName: cn(
						'absolute top-[548px] left-[256px] w-[53px] z-[1]'
					),
					className: 'text-xs text-center',
					regex: REGEX.ALLOW_KR_EN_SPECIAL_CHARS,
				}),
				// (values, index) => ({
				// 	name: 'position',
				// 	maxHeight: 24,
				// 	maxLength: 3,
				// 	className: 'text-[16px] text-center',
				// 	containerClassName: cn(
				// 		'absolute top-[627px] left-[37.8%] w-[43px]',
				// 		values?.city && 'bg-white'
				// 	),
				// }),
				(values, index) => ({
					name: 'city',
					maxHeight: 18,
					maxLength: 8,
					containerClassName: cn(
						'absolute top-[691px] left-[78px] w-[66px] z-[1]'
						// values?.city && 'bg-white'
					),
					className: 'text-xs text-center',
					regex: REGEX.ALLOW_KR_EN_SPECIAL_CHARS,
				}),
				(values, index) => ({
					name: 'city',
					maxHeight: 20,
					maxLength: 8,
					containerClassName: cn(
						'absolute top-[730px] left-[268px] w-[61px]'
						// values?.city && 'bg-white'
					),
					className: 'text-xs text-center',
					regex: REGEX.ALLOW_KR_EN_SPECIAL_CHARS,
				}),
				{
					name: 'participationTime',
					maxHeight: 24,
					maxLength: 3,
					containerClassName:
						'absolute top-[402px] left-[69%] w-[33px] items-end',
					className: 'text-[14px] leading-none text-center ',
				},
				{
					name: 'participationTime',
					maxHeight: 24,
					maxLength: 3,
					containerClassName:
						'absolute top-[402px] left-[595px] w-[33px] items-end',
					className: 'text-[14px] leading-none text-center ',
				},
				{
					name: 'participationMonth',
					maxHeight: 22,
					maxLength: 3,
					containerClassName:
						'absolute top-[422px] left-[558px] w-[33px] items-end',
					className: 'text-[16px] leading-none text-center',
				},
				{
					name: 'participationMonth',
					maxHeight: 22,
					maxLength: 3,
					containerClassName:
						'absolute top-[442px] left-[579px] w-[33px] items-end',
					className: 'text-[16px] leading-none text-center',
				},
				(values, index) => ({
					name: 'district',
					maxHeight: 40,
					maxLength: 20,
					containerClassName: cn(
						'absolute top-[843px] left-[151px] w-[85px] z-[1] items-center'
					),
					className: 'text-[13px] text-center',
				}),
				// (values, index) => ({
				// 	name: 'position1',
				// 	maxHeight: 24,
				// 	maxLength: 6,
				// 	className: 'text-[16px] text-center',
				// 	containerClassName: cn(
				// 		'absolute top-[969px] left-[260px] w-[85px]',
				// 		values?.mayor && 'bg-white'
				// 	),
				// 	readOnly: true,
				// }),
			],
			datePickers: [
				{
					name: 'birthDate',
					containerClassName: 'absolute top-[369px] left-[26.8%]',
					className:
						'[&>.ant-picker-input>input]:!text-[16px] [&>.ant-picker-input>input]:!w-[238px]',
					style: {
						width: '238px',
						textAlign: 'center',
					},
				},
				{
					name: 'date',
					segmentedInputs: true,
					containerClassName: 'absolute top-[801px] left-[264px]',
					format: 'YYYY              MM                DD',
					style: { fontSize: '14px' },
					boxStyle: { marginTop: '-8px' },
				},
			],
			cachetForms: [
				{
					className: 'absolute top-[810px] left-[513px] w-[90px] h-[90px]',
				},
			],
			highlightBoxes: [
				{
					name: 'name',
					className: 'w-[50px] !h-[18px] top-[315px] left-[117px]',
				},
				{
					name: 'gender',
					className: 'w-[36px] !h-[18px] top-[315px] left-[481px]',
				},
				{
					name: 'birthDate',
					className: 'w-[80px] !h-[18px] top-[359px] left-[102px]',
				},
				{
					name: 'national',
					className: 'w-[37px] !h-[18px] top-[359px] left-[480px]',
				},
				{
					name: 'workPeriod',
					className: 'w-[80px] !h-[18px] top-[417px] left-[102px]',
				},
				{
					name: 'participationTime',
					className: 'w-[65px] !h-[18px] top-[411px] left-[466px]',
				},
				{
					name: 'workplace',
					className: 'w-[134px] !h-[18px] top-[465px] left-[77px]',
				},
				{
					name: 'city',
					className: 'w-[53px] !h-[18px] top-[548px] left-[256px]',
				},
				{
					name: 'city',
					className: 'w-[66px] !h-[18px] top-[689px] left-[79px]',
				},
				{
					name: 'city',
					className: 'w-[59px] !h-[18px] top-[729px] left-[271px]',
				},
				{
					name: 'date',
					className: 'w-[220px] !h-[27px] top-[792px] left-[260px]',
				},
				// {
				// 	name: 'mayor',
				// 	className: 'w-[85px] !h-[20px] top-[978px] left-[219px]',
				// },
				{
					name: 'sealIdFilePath',
					className: 'w-[30px] !h-[20px] top-[857px] left-[413px]',
				},
				{
					name: 'district',
					className: 'w-[85px] !h-[20px] top-[855px] left-[151px]',
				},
			],
		},
	],
	validationSchema: Yup.object().shape({
		name: Yup.string().required(),
		gender: Yup.string().required(),
		birthDate: Yup.string().required(),
		national: Yup.string().required(),
		workplace: Yup.string().required(),
		city: Yup.string().required(),
		date: Yup.string().required(),
		mayor: Yup.string().required(),
	}),
};
